export const welcomeAsset = (filename: string) => `/assets/welcome/${filename}`;

export type ApplicationScreen = {
    id: 'automate' | 'recurrences' | 'notes';
    src: string;
    title: string;
    label: string;
    width: number;
    height: number;
    alt: string;
};

export const applicationScreens: readonly ApplicationScreen[] = [
    {
        id: 'automate',
        src: welcomeAsset('application-automation-controls.png'),
        title: 'Emissão automática',
        label: 'Automatizar',
        width: 446,
        height: 276,
        alt: 'Controles reais da recorrência na Servion: frequência mensal, próximas emissões e opção de emissão automática ativada. Dados de demonstração.',
    },
    {
        id: 'recurrences',
        src: welcomeAsset('application-recurrences-focus.png'),
        title: 'Próximas emissões',
        label: 'Próximas emissões',
        width: 726,
        height: 228,
        alt: 'Tabela real de recorrências da Servion com frequência, próxima emissão e modos Automático e Revisar antes. Dados de demonstração.',
    },
    {
        id: 'notes',
        src: welcomeAsset('application-notes-focus.png'),
        title: 'Notas fiscais',
        label: 'Notas fiscais',
        width: 1126,
        height: 472,
        alt: 'Recorte real da listagem de NFS-e da Servion: tomador, valor, competência, rascunhos e notas emitidas. Dados de demonstração.',
    },
];

export type WelcomeAction = { href: string; label: string };
export type OpenWelcomeDialog = (id: string, trigger: HTMLElement) => void;

export const welcomeMeta = {
    title: 'Menos tempo na nota fiscal, mais no seu negócio',
    description:
        'Servion — emissão e organização de NFS-e, com mais espaço para seu negócio.',
};
